import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Modal } from "react-materialize";
import axios from "axios";

const MenuRow = ({
  title,
  description,
  img,
  rating,
  _id,
  category,
  handleDelete,
}) => {


  const onDelete = () => {
    axios.delete(`/services/${_id}`)
      .then((res) => window.location.reload())
      .catch((err) => console.log(err));
  };


  return (
    <tr key={_id}>
      <td>{title}</td>
      <td>{description}</td>
      <td>
        <img src={img} alt={title} style={{ height: "3em" }}></img>
      </td>
      <td>{category}</td>
      <td>${rating}</td>
      <td className="menuIcon">
        <Link to={`/admin/menu/update/${_id}`}>
          <FontAwesomeIcon icon={faEdit} className="iconlink" />
        </Link>
      </td>
      <td className="table-col">
        <Modal
          trigger={
            <button className="btn delete-queue">
              <FontAwesomeIcon className="blk" icon={faTrash} size="s" />
            </button>
          }
        >
          <div className="modal-container">
            <h4>Confirm Delete</h4>
            <p>Are you sure you want to delete this from your queue?</p>
            <button className="btn submit-button" onClick={onDelete}>
              Yes, Delete{" "}
            </button>
          </div>
        </Modal>
      </td>
    </tr>
  );
};

export default MenuRow;
